import { render, staticRenderFns } from "./AbandonAuditMsg.vue?vue&type=template&id=584d9f07&scoped=true&"
import script from "./AbandonAuditMsg.vue?vue&type=script&lang=js&"
export * from "./AbandonAuditMsg.vue?vue&type=script&lang=js&"
import style0 from "./AbandonAuditMsg.vue?vue&type=style&index=0&id=584d9f07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d9f07",
  null
  
)

export default component.exports